var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStrikeThrough = function SvgStrikeThrough(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 17,
    viewBox: "0 0 109 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.805234,
    y1: 15.5127,
    x2: 107.891,
    y2: 1.48957,
    stroke: "#76BF43",
    strokeWidth: 3
  })));
};
export default SvgStrikeThrough;